/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuditLogListResponse,
  AuditLogResponse,
  AuditLogSearchRequest,
  AuditMetadataResponse,
  AuditStatisticsResponse,
} from '../models/index';
import {
    AuditLogListResponseFromJSON,
    AuditLogListResponseToJSON,
    AuditLogResponseFromJSON,
    AuditLogResponseToJSON,
    AuditLogSearchRequestFromJSON,
    AuditLogSearchRequestToJSON,
    AuditMetadataResponseFromJSON,
    AuditMetadataResponseToJSON,
    AuditStatisticsResponseFromJSON,
    AuditStatisticsResponseToJSON,
} from '../models/index';

export interface GetAllAuditStatisticsRequest {
    sessionId?: string;
}

export interface GetAuditLogRequest {
    auditLogId: string;
    sessionId?: string;
}

export interface GetAuditLoggingStatusRequest {
    sessionId?: string;
}

export interface GetAuditLogsByCategoryRequest {
    category: string;
    auditLogSearchRequest: AuditLogSearchRequest;
    sessionId?: string;
}

export interface GetAuditLogsByResourceRequest {
    resourceType: string;
    resourceId: string;
    auditLogSearchRequest: AuditLogSearchRequest;
    sessionId?: string;
}

export interface GetAuditLogsBySeverityRequest {
    severity: string;
    auditLogSearchRequest: AuditLogSearchRequest;
    sessionId?: string;
}

export interface GetAuditLogsByUserRequest {
    userId: string;
    auditLogSearchRequest: AuditLogSearchRequest;
    sessionId?: string;
}

export interface GetAuditMetadataRequest {
    sessionId?: string;
    page?: number;
    pageSize?: number;
}

export interface GetAuditStatisticsRequest {
    sessionId?: string;
}

export interface GetAuthenticationLogsRequest {
    sessionId?: string;
}

export interface GetAuthorizationLogsRequest {
    sessionId?: string;
}

export interface GetCriticalSeverityLogsRequest {
    sessionId?: string;
}

export interface GetDataModificationLogsRequest {
    sessionId?: string;
}

export interface GetFailedOperationLogsRequest {
    sessionId?: string;
}

export interface GetHighSeverityLogsRequest {
    sessionId?: string;
}

export interface GetSecurityEventLogsRequest {
    sessionId?: string;
}

export interface GetSystemErrorLogsRequest {
    sessionId?: string;
}

export interface SearchAllAuditLogsRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface SearchAuditLogsRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * AuditApi - interface
 * 
 * @export
 * @interface AuditApiInterface
 */
export interface AuditApiInterface {
    /**
     * Retrieves audit statistics across all tenants (admin only)
     * @summary Get all audit statistics (admin)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAllAuditStatisticsRaw(requestParameters: GetAllAuditStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditStatisticsResponse>>;

    /**
     * Retrieves audit statistics across all tenants (admin only)
     * Get all audit statistics (admin)
     */
    getAllAuditStatistics(requestParameters: GetAllAuditStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditStatisticsResponse>;

    /**
     * Retrieves a specific audit log entry by ID
     * @summary Get audit log by ID
     * @param {string} auditLogId Audit log ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditLogRaw(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogResponse>>;

    /**
     * Retrieves a specific audit log entry by ID
     * Get audit log by ID
     */
    getAuditLog(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogResponse>;

    /**
     * Retrieves the current audit logging mode (async/sync) and status information
     * @summary Get audit logging status
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditLoggingStatusRaw(requestParameters: GetAuditLoggingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the current audit logging mode (async/sync) and status information
     * Get audit logging status
     */
    getAuditLoggingStatus(requestParameters: GetAuditLoggingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves audit logs for a specific category
     * @summary Get audit logs by category
     * @param {string} category Audit category
     * @param {AuditLogSearchRequest} auditLogSearchRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditLogsByCategoryRaw(requestParameters: GetAuditLogsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves audit logs for a specific category
     * Get audit logs by category
     */
    getAuditLogsByCategory(requestParameters: GetAuditLogsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves audit logs for a specific resource
     * @summary Get audit logs by resource
     * @param {string} resourceType Resource type
     * @param {string} resourceId Resource ID
     * @param {AuditLogSearchRequest} auditLogSearchRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditLogsByResourceRaw(requestParameters: GetAuditLogsByResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves audit logs for a specific resource
     * Get audit logs by resource
     */
    getAuditLogsByResource(requestParameters: GetAuditLogsByResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves audit logs for a specific severity level
     * @summary Get audit logs by severity
     * @param {string} severity Audit severity
     * @param {AuditLogSearchRequest} auditLogSearchRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditLogsBySeverityRaw(requestParameters: GetAuditLogsBySeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves audit logs for a specific severity level
     * Get audit logs by severity
     */
    getAuditLogsBySeverity(requestParameters: GetAuditLogsBySeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves audit logs for a specific user
     * @summary Get audit logs by user
     * @param {string} userId User ID
     * @param {AuditLogSearchRequest} auditLogSearchRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditLogsByUserRaw(requestParameters: GetAuditLogsByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves audit logs for a specific user
     * Get audit logs by user
     */
    getAuditLogsByUser(requestParameters: GetAuditLogsByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves available audit categories, severity levels, resource types, and actions for frontend use
     * @summary Get audit metadata
     * @param {string} [sessionId] Session ID for authorization
     * @param {number} [page] Page number (optional, defaults to 1)
     * @param {number} [pageSize] Page size (optional, defaults to 100, max 1000)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditMetadataRaw(requestParameters: GetAuditMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditMetadataResponse>>;

    /**
     * Retrieves available audit categories, severity levels, resource types, and actions for frontend use
     * Get audit metadata
     */
    getAuditMetadata(requestParameters: GetAuditMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditMetadataResponse>;

    /**
     * Retrieves audit log statistics and metrics
     * @summary Get audit statistics
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuditStatisticsRaw(requestParameters: GetAuditStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditStatisticsResponse>>;

    /**
     * Retrieves audit log statistics and metrics
     * Get audit statistics
     */
    getAuditStatistics(requestParameters: GetAuditStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditStatisticsResponse>;

    /**
     * Retrieves authentication-related audit logs
     * @summary Get authentication logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuthenticationLogsRaw(requestParameters: GetAuthenticationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves authentication-related audit logs
     * Get authentication logs
     */
    getAuthenticationLogs(requestParameters: GetAuthenticationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves authorization-related audit logs
     * @summary Get authorization logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getAuthorizationLogsRaw(requestParameters: GetAuthorizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves authorization-related audit logs
     * Get authorization logs
     */
    getAuthorizationLogs(requestParameters: GetAuthorizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves critical severity audit logs
     * @summary Get critical severity logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getCriticalSeverityLogsRaw(requestParameters: GetCriticalSeverityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves critical severity audit logs
     * Get critical severity logs
     */
    getCriticalSeverityLogs(requestParameters: GetCriticalSeverityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves data modification audit logs
     * @summary Get data modification logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getDataModificationLogsRaw(requestParameters: GetDataModificationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves data modification audit logs
     * Get data modification logs
     */
    getDataModificationLogs(requestParameters: GetDataModificationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves failed operation audit logs
     * @summary Get failed operation logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getFailedOperationLogsRaw(requestParameters: GetFailedOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves failed operation audit logs
     * Get failed operation logs
     */
    getFailedOperationLogs(requestParameters: GetFailedOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves high severity audit logs
     * @summary Get high severity logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getHighSeverityLogsRaw(requestParameters: GetHighSeverityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves high severity audit logs
     * Get high severity logs
     */
    getHighSeverityLogs(requestParameters: GetHighSeverityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves security event audit logs
     * @summary Get security event logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getSecurityEventLogsRaw(requestParameters: GetSecurityEventLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves security event audit logs
     * Get security event logs
     */
    getSecurityEventLogs(requestParameters: GetSecurityEventLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves system error audit logs
     * @summary Get system error logs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    getSystemErrorLogsRaw(requestParameters: GetSystemErrorLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves system error audit logs
     * Get system error logs
     */
    getSystemErrorLogs(requestParameters: GetSystemErrorLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Searches audit logs across all tenants (admin only)
     * @summary Search all audit logs (admin)
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    searchAllAuditLogsRaw(requestParameters: SearchAllAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Searches audit logs across all tenants (admin only)
     * Search all audit logs (admin)
     */
    searchAllAuditLogs(requestParameters: SearchAllAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

    /**
     * Retrieves paginated audit logs with filtering options. Each audit log includes user information (userId, username), tenant information (tenantId, tenantName), and detailed action context.
     * @summary Search audit logs
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditApiInterface
     */
    searchAuditLogsRaw(requestParameters: SearchAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>>;

    /**
     * Retrieves paginated audit logs with filtering options. Each audit log includes user information (userId, username), tenant information (tenantId, tenantName), and detailed action context.
     * Search audit logs
     */
    searchAuditLogs(requestParameters: SearchAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse>;

}

/**
 * 
 */
export class AuditApi extends runtime.BaseAPI implements AuditApiInterface {

    /**
     * Retrieves audit statistics across all tenants (admin only)
     * Get all audit statistics (admin)
     */
    async getAllAuditStatisticsRaw(requestParameters: GetAllAuditStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditStatisticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/admin/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves audit statistics across all tenants (admin only)
     * Get all audit statistics (admin)
     */
    async getAllAuditStatistics(requestParameters: GetAllAuditStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditStatisticsResponse> {
        const response = await this.getAllAuditStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific audit log entry by ID
     * Get audit log by ID
     */
    async getAuditLogRaw(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogResponse>> {
        if (requestParameters['auditLogId'] == null) {
            throw new runtime.RequiredError(
                'auditLogId',
                'Required parameter "auditLogId" was null or undefined when calling getAuditLog().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/{auditLogId}`;
        urlPath = urlPath.replace(`{${"auditLogId"}}`, encodeURIComponent(String(requestParameters['auditLogId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific audit log entry by ID
     * Get audit log by ID
     */
    async getAuditLog(requestParameters: GetAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogResponse> {
        const response = await this.getAuditLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current audit logging mode (async/sync) and status information
     * Get audit logging status
     */
    async getAuditLoggingStatusRaw(requestParameters: GetAuditLoggingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the current audit logging mode (async/sync) and status information
     * Get audit logging status
     */
    async getAuditLoggingStatus(requestParameters: GetAuditLoggingStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAuditLoggingStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves audit logs for a specific category
     * Get audit logs by category
     */
    async getAuditLogsByCategoryRaw(requestParameters: GetAuditLogsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling getAuditLogsByCategory().'
            );
        }

        if (requestParameters['auditLogSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'auditLogSearchRequest',
                'Required parameter "auditLogSearchRequest" was null or undefined when calling getAuditLogsByCategory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit/category/{category}/search`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuditLogSearchRequestToJSON(requestParameters['auditLogSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves audit logs for a specific category
     * Get audit logs by category
     */
    async getAuditLogsByCategory(requestParameters: GetAuditLogsByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getAuditLogsByCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves audit logs for a specific resource
     * Get audit logs by resource
     */
    async getAuditLogsByResourceRaw(requestParameters: GetAuditLogsByResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getAuditLogsByResource().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling getAuditLogsByResource().'
            );
        }

        if (requestParameters['auditLogSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'auditLogSearchRequest',
                'Required parameter "auditLogSearchRequest" was null or undefined when calling getAuditLogsByResource().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit/resource/{resourceType}/{resourceId}/search`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));
        urlPath = urlPath.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters['resourceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuditLogSearchRequestToJSON(requestParameters['auditLogSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves audit logs for a specific resource
     * Get audit logs by resource
     */
    async getAuditLogsByResource(requestParameters: GetAuditLogsByResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getAuditLogsByResourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves audit logs for a specific severity level
     * Get audit logs by severity
     */
    async getAuditLogsBySeverityRaw(requestParameters: GetAuditLogsBySeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        if (requestParameters['severity'] == null) {
            throw new runtime.RequiredError(
                'severity',
                'Required parameter "severity" was null or undefined when calling getAuditLogsBySeverity().'
            );
        }

        if (requestParameters['auditLogSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'auditLogSearchRequest',
                'Required parameter "auditLogSearchRequest" was null or undefined when calling getAuditLogsBySeverity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit/severity/{severity}/search`;
        urlPath = urlPath.replace(`{${"severity"}}`, encodeURIComponent(String(requestParameters['severity'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuditLogSearchRequestToJSON(requestParameters['auditLogSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves audit logs for a specific severity level
     * Get audit logs by severity
     */
    async getAuditLogsBySeverity(requestParameters: GetAuditLogsBySeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getAuditLogsBySeverityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves audit logs for a specific user
     * Get audit logs by user
     */
    async getAuditLogsByUserRaw(requestParameters: GetAuditLogsByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getAuditLogsByUser().'
            );
        }

        if (requestParameters['auditLogSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'auditLogSearchRequest',
                'Required parameter "auditLogSearchRequest" was null or undefined when calling getAuditLogsByUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit/user/{userId}/search`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuditLogSearchRequestToJSON(requestParameters['auditLogSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves audit logs for a specific user
     * Get audit logs by user
     */
    async getAuditLogsByUser(requestParameters: GetAuditLogsByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getAuditLogsByUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves available audit categories, severity levels, resource types, and actions for frontend use
     * Get audit metadata
     */
    async getAuditMetadataRaw(requestParameters: GetAuditMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditMetadataResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/metadata`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditMetadataResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves available audit categories, severity levels, resource types, and actions for frontend use
     * Get audit metadata
     */
    async getAuditMetadata(requestParameters: GetAuditMetadataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditMetadataResponse> {
        const response = await this.getAuditMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves audit log statistics and metrics
     * Get audit statistics
     */
    async getAuditStatisticsRaw(requestParameters: GetAuditStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditStatisticsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves audit log statistics and metrics
     * Get audit statistics
     */
    async getAuditStatistics(requestParameters: GetAuditStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditStatisticsResponse> {
        const response = await this.getAuditStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves authentication-related audit logs
     * Get authentication logs
     */
    async getAuthenticationLogsRaw(requestParameters: GetAuthenticationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/authentication`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves authentication-related audit logs
     * Get authentication logs
     */
    async getAuthenticationLogs(requestParameters: GetAuthenticationLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getAuthenticationLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves authorization-related audit logs
     * Get authorization logs
     */
    async getAuthorizationLogsRaw(requestParameters: GetAuthorizationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/authorization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves authorization-related audit logs
     * Get authorization logs
     */
    async getAuthorizationLogs(requestParameters: GetAuthorizationLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getAuthorizationLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves critical severity audit logs
     * Get critical severity logs
     */
    async getCriticalSeverityLogsRaw(requestParameters: GetCriticalSeverityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/critical-severity`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves critical severity audit logs
     * Get critical severity logs
     */
    async getCriticalSeverityLogs(requestParameters: GetCriticalSeverityLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getCriticalSeverityLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves data modification audit logs
     * Get data modification logs
     */
    async getDataModificationLogsRaw(requestParameters: GetDataModificationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/data-modifications`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves data modification audit logs
     * Get data modification logs
     */
    async getDataModificationLogs(requestParameters: GetDataModificationLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getDataModificationLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves failed operation audit logs
     * Get failed operation logs
     */
    async getFailedOperationLogsRaw(requestParameters: GetFailedOperationLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/failed-operations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves failed operation audit logs
     * Get failed operation logs
     */
    async getFailedOperationLogs(requestParameters: GetFailedOperationLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getFailedOperationLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves high severity audit logs
     * Get high severity logs
     */
    async getHighSeverityLogsRaw(requestParameters: GetHighSeverityLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/high-severity`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves high severity audit logs
     * Get high severity logs
     */
    async getHighSeverityLogs(requestParameters: GetHighSeverityLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getHighSeverityLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves security event audit logs
     * Get security event logs
     */
    async getSecurityEventLogsRaw(requestParameters: GetSecurityEventLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/security-events`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves security event audit logs
     * Get security event logs
     */
    async getSecurityEventLogs(requestParameters: GetSecurityEventLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getSecurityEventLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves system error audit logs
     * Get system error logs
     */
    async getSystemErrorLogsRaw(requestParameters: GetSystemErrorLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/audit/system-errors`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves system error audit logs
     * Get system error logs
     */
    async getSystemErrorLogs(requestParameters: GetSystemErrorLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.getSystemErrorLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches audit logs across all tenants (admin only)
     * Search all audit logs (admin)
     */
    async searchAllAuditLogsRaw(requestParameters: SearchAllAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling searchAllAuditLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit/admin/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Searches audit logs across all tenants (admin only)
     * Search all audit logs (admin)
     */
    async searchAllAuditLogs(requestParameters: SearchAllAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.searchAllAuditLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated audit logs with filtering options. Each audit log includes user information (userId, username), tenant information (tenantId, tenantName), and detailed action context.
     * Search audit logs
     */
    async searchAuditLogsRaw(requestParameters: SearchAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditLogListResponse>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling searchAuditLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/audit/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditLogListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated audit logs with filtering options. Each audit log includes user information (userId, username), tenant information (tenantId, tenantName), and detailed action context.
     * Search audit logs
     */
    async searchAuditLogs(requestParameters: SearchAuditLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditLogListResponse> {
        const response = await this.searchAuditLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
